"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";

type PixelWindow = Window & {
  fbq?: (...args: unknown[]) => void;
  ttq?: { instance: (pixelId: string) => { page: () => void } };
};

const VenueAnalyticsRoutePageView: React.FC<{
  metaPixelIds: string[];
  tiktokPixelIds: string[];
}> = ({ metaPixelIds, tiktokPixelIds }) => {
  const pathname = usePathname();
  const lastPathnameRef = useRef(pathname);

  useEffect(() => {
    if (lastPathnameRef.current === pathname) return;
    lastPathnameRef.current = pathname;

    const { fbq, ttq } = window as PixelWindow;
    metaPixelIds.forEach((id) => fbq?.("trackSingle", id, "PageView"));
    tiktokPixelIds.forEach((id) => ttq?.instance(id).page());
  }, [pathname, metaPixelIds, tiktokPixelIds]);

  return null;
};

export default VenueAnalyticsRoutePageView;
